import { render, staticRenderFns } from "./AppTableDesign.vue?vue&type=template&id=60fd236c&"
import script from "./AppTableDesign.vue?vue&type=script&lang=ts&"
export * from "./AppTableDesign.vue?vue&type=script&lang=ts&"
import style0 from "./AppTableDesign.vue?vue&type=style&index=0&id=60fd236c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports